import _extends from "@babel/runtime/helpers/extends";
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var MapSource = /*#__PURE__*/function () {
  function MapSource(storeKey, callBack, doLog, MessageCenter) {
    var _this = this;
    this.storeKey = void 0;
    this.storeMap = new Map();
    this.callBack = null;
    this.storageEvent = new Event('storageChange');
    this.doLog = null;
    this.timer = void 0;
    this.MessageCenter = null;
    var oldData = localStorage.getItem(storeKey);
    this.storeKey = storeKey;
    this.callBack = callBack;
    this.doLog = doLog;
    this.MessageCenter = MessageCenter;
    var oldMap = {};
    try {
      oldMap = oldData ? JSON.parse(oldData) : {};
    } catch (e) {
      // do nothing
    }
    Object.keys(oldMap).forEach(function (key) {
      if (oldMap[key]) {
        _this.storeMap.set(key, oldMap[key]);
      }
    });
    this.startTimer();
    window.addEventListener('storageChange', function () {
      _this.startTimer();
    });
  }
  var _proto = MapSource.prototype;
  _proto.addItem = function addItem(content) {
    var originData = this.parseWet(content) || {};
    var _originData$tryTimes = originData.tryTimes,
      tryTimes = _originData$tryTimes === void 0 ? 0 : _originData$tryTimes,
      data = originData.data;
    var _ref = data || {},
      task = _ref.task;
    var _ref2 = task || {},
      _ref2$taskID = _ref2.taskID,
      taskID = _ref2$taskID === void 0 ? '' : _ref2$taskID;
    if (tryTimes || !taskID) {
      return;
    }
    var key = taskID;
    var value = originData;
    this.storageEvent.newValue = value;
    value.timeStamp = Date.now();
    this.storeMap.set(key, value);
    var store = this.mapToJson(this.storeMap);
    this.storageEvent.store = store;
    localStorage.setItem(this.storeKey, JSON.stringify(store));
    window.dispatchEvent(this.storageEvent);
  };
  _proto.removeItem = function removeItem(key) {
    var newValue = this.storeMap.get(key);
    if (!newValue) {
      return;
    }
    newValue && (this.storageEvent.newValue = newValue);
    newValue && this.storeMap["delete"](key);
    if (newValue && newValue.tryTimes) {
      try {
        var _this$doLog;
        var data = newValue.data;
        var _ref3 = data || {},
          task = _ref3.task,
          traceId = _ref3.traceId,
          bizCode = _ref3.bizCode;
        var _ref4 = task || {},
          _ref4$taskID = _ref4.taskID,
          taskID = _ref4$taskID === void 0 ? '' : _ref4$taskID,
          _ref4$printer = _ref4.printer,
          printer = _ref4$printer === void 0 ? '' : _ref4$printer;
        this === null || this === void 0 ? void 0 : (_this$doLog = this.doLog) === null || _this$doLog === void 0 ? void 0 : _this$doLog.call(this, {
          process: 'FRONT_END',
          action: 'retrySendSuccess',
          traceId: traceId,
          bizCode: bizCode,
          printer: printer,
          taskID: taskID
        });
      } catch (e) {
        // do nothing
      }
    }
    var store = this.mapToJson(this.storeMap);
    this.storageEvent.store = store;
    localStorage.setItem(this.storeKey, JSON.stringify(store));
    window.dispatchEvent(this.storageEvent);
  };
  _proto.startTimer = function startTimer() {
    var _this2 = this;
    var obj = this.mapToJson(this.storeMap);
    var isEmpty = Object.keys(obj);
    if (isEmpty.length) {
      this.timer = setInterval(function () {
        obj = _this2.mapToJson(_this2.storeMap);
        Object.keys(obj).forEach(function (key) {
          var item = obj[key];
          var data = item.data;
          var _ref5 = data || {},
            task = _ref5.task,
            _ref5$traceId = _ref5.traceId,
            traceId = _ref5$traceId === void 0 ? '' : _ref5$traceId,
            bizCode = _ref5.bizCode;
          var _ref6 = task || {},
            _ref6$taskID = _ref6.taskID,
            taskID = _ref6$taskID === void 0 ? '' : _ref6$taskID,
            _ref6$printer = _ref6.printer,
            printer = _ref6$printer === void 0 ? '' : _ref6$printer;
          if (((item === null || item === void 0 ? void 0 : item.tryTimes) || 0) >= 2 || Date.now() - ((item === null || item === void 0 ? void 0 : item.timeStamp) || 0) > 3600000) {
            _this2.removeItem(taskID);
            try {
              var _this2$doLog, _this2$MessageCenter, _this2$MessageCenter$;
              _this2 === null || _this2 === void 0 ? void 0 : (_this2$doLog = _this2.doLog) === null || _this2$doLog === void 0 ? void 0 : _this2$doLog.call(_this2, {
                process: 'FRONT_END',
                action: 'retrySendFailed',
                request: item,
                traceId: traceId
              });
              var res = {
                dataSource: 'CAINIAO',
                data: _extends({
                  cmd: 'notifyPrintError',
                  errorMessage: '打印任务异常，请检查是否有漏打情况'
                }, item, {
                  traceId: traceId,
                  taskID: taskID,
                  printer: printer,
                  bizCode: bizCode
                })
              };
              (_this2$MessageCenter = _this2.MessageCenter) === null || _this2$MessageCenter === void 0 ? void 0 : (_this2$MessageCenter$ = _this2$MessageCenter.listen) === null || _this2$MessageCenter$ === void 0 ? void 0 : _this2$MessageCenter$.call(_this2$MessageCenter, res);
            } catch (e) {
              // do nothing
            }
          }
          if (Date.now() - ((item === null || item === void 0 ? void 0 : item.timeStamp) || 0) >= 60000 && (!item.tryTimes || item.tryTimes < 2)) {
            var _this2$callBack, _this2$callBack$next;
            item.tryTimes = item.tryTimes ? item.tryTimes + 1 : 1;
            item.timeStamp = Date.now();
            _this2.callBack && ((_this2$callBack = _this2.callBack) === null || _this2$callBack === void 0 ? void 0 : (_this2$callBack$next = _this2$callBack.next) === null || _this2$callBack$next === void 0 ? void 0 : _this2$callBack$next.call(_this2$callBack, _this2.stringifyWet(item)));
          }
        });
      }, 30000);
    } else {
      // @ts-ignore
      clearInterval(this.timer);
    }
  };
  _proto.clearItem = function clearItem() {
    this.storeMap.clear();
    // @ts-ignore
    clearInterval(this.timer);
  };
  _proto.parseWet = function parseWet(data) {
    var result = '';
    var output;
    if (typeof data !== 'string') {
      return {};
    }
    result = data.replace(String.fromCharCode(2), '').replace(String.fromCharCode(3), '');
    try {
      output = JSON.parse(result);
    } catch (e) {
      // do nothing
    }
    return output;
  };
  _proto.stringifyWet = function stringifyWet(data) {
    return String.fromCharCode(2) + JSON.stringify(data) + String.fromCharCode(3);
  };
  _proto.mapToJson = function mapToJson(tmpMap) {
    var jsonObj = {};
    for (var _iterator = _createForOfIteratorHelperLoose(tmpMap), _step; !(_step = _iterator()).done;) {
      var _step$value = _step.value,
        _key = _step$value[0],
        value = _step$value[1];
      jsonObj[_key] = value;
    }
    return jsonObj;
  };
  _proto.jsonToMap = function jsonToMap(origin) {
    var newMap = new Map();
    Object.keys(origin).forEach(function (key) {
      newMap.set(key, origin[key]);
    });
    return newMap;
  };
  return MapSource;
}();
export default MapSource;